import { PropsWithChildren, SVGProps } from 'react';

type SvgProps = PropsWithChildren<SVGProps<SVGSVGElement>>;

export const Svg = ({ children, ...rest }: SvgProps) => (
  <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" {...rest}>
    {children}
  </svg>
);
